import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

import { Directive } from '@angular/core';
import { Answers, AnswerValue } from '@shared/services/lifemap/lifemap.service';

export enum CustomErrorsLifemapQuestions {
  notAllQuestionsAnswered = 'notAllQuestionsAnswered',
}

export function plValidateLifemapQuestions(c: AbstractControl): ValidationErrors | null {
  console.log('TONIO plValidateLifemapQuestions plValidateLifemapQuestions c=', c);
  const answers: Answers = c.value;

  for (let index: number = 0; index < answers.length; index++) {
    const answerValue: AnswerValue = answers[index];
    if (answerValue === null) {
      return {
        [CustomErrorsLifemapQuestions.notAllQuestionsAnswered]: index + 1,
      };
    }
  }

  return null;
}

@Directive({
  selector: '[plValidateLifemapQuestions][ngModel]',
  providers: [{ provide: NG_VALIDATORS, useValue: plValidateLifemapQuestions, multi: true }],
})
export class LifemapQuestionsValidatorDirective {}
